import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { articlePath, formatNewsDate } from '../helpers';
import styles from '../News.module.css';

const NewsArticleCard = ({ article, featured }) => (
  <Link
    to={articlePath(article.slug)}
    data-part="news-card"
    data-variant={featured ? 'featured' : undefined}
    className={`${styles.card} ${featured ? styles.featuredCard : ''} text-dark dark:text-white`}
  >
    {article.image && (
      <div className={styles.frame}>
        <img
          src={article.image}
          alt=""
          loading="lazy"
          className={`${styles.ratio3x2} w-full h-auto object-cover`}
        />
      </div>
    )}
    <div className={styles.cardBody}>
      <time dateTime={article.publishedAt} data-part="news-date" className="font-montserratMedium text-sm text-darkElevationPrimary dark:text-darkElevationSecondary">
        {formatNewsDate(article.publishedAt)}
      </time>
      <h2 className={featured ? styles.featuredTitle : styles.cardTitle}>
        {article.title}
      </h2>
      <p className={`font-montserratMedium ${featured ? `text-lg ${styles.clamp5}` : `text-base ${styles.clamp3}`}`}>
        {article.excerpt}
      </p>
    </div>
  </Link>
);

NewsArticleCard.propTypes = {
  article: PropTypes.shape({
    slug: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    excerpt: PropTypes.string,
    image: PropTypes.string,
    publishedAt: PropTypes.string,
  }).isRequired,
  featured: PropTypes.bool,
};

NewsArticleCard.defaultProps = {
  featured: false,
};

export default NewsArticleCard;
